export default __webpack_public_path__ + "static/media/capsule-landing-token-tether.13f315c4.png";